/** @file Select: a themed single-choice dropdown over string values. */
import type { ReactElement } from 'react';

/** One option: the value reported and the text shown. */
export type SelectOption = { value: string; label: string };

/** The current value, the options and the change callback. */
export type SelectProps = { value: string; options: SelectOption[]; onChange: (value: string) => void; label?: string; disabled?: boolean };

/** A `<select>`; an unknown `value` shows the first option's text without reporting a change. */
export function Select({ value, options, onChange, label, disabled }: SelectProps): ReactElement {
  return (
    <select className="p3-select" aria-label={label} value={value} disabled={disabled} onChange={(e) => { onChange(e.target.value); }}>
      {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );
}
